import type { ICampaignPriceSetupGuide } from '../hooks/useCampaignPriceSetupGuide';

import { useCampaignPriceSetupGuide } from '../hooks/useCampaignPriceSetupGuide';
import { createContext, useContext } from 'react';

const CampaignPriceSetupGuideContext = createContext<ICampaignPriceSetupGuide | null>(null);

export const useCampaignPriceSetupGuideContext = (): ICampaignPriceSetupGuide => {
  const context = useContext(CampaignPriceSetupGuideContext);
  if (!context) {
    throw new Error(
      'useCampaignPriceSetupGuideContext must be used within a CampaignPriceSetupGuideProvider',
    );
  }

  return context;
};

export const CampaignPriceSetupGuideProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <CampaignPriceSetupGuideContext.Provider value={useCampaignPriceSetupGuide()}>
    {children}
  </CampaignPriceSetupGuideContext.Provider>
);
